/**
 * GALATEA SIGNATURE - OVERRIDE REGIONAL: ARGENTINA (es-AR)
 */

export const esAROverride = {
  entities: {
    document: 'CUIT / CUIL / DNI',
    state: 'Provincia',
    fiscal: 'Información AFIP',
  },
};

export default esAROverride;
